import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import "./Navbar.css";
import { useLanguage, LanguageSwitch } from "../Language";

const sections = [
  { id: "examples", label: "Beispiele" },
  { id: "products", label: "Produkte" },
  { id: "contact", label: "Kontakt" },
];

function Navbar() {
  const { t } = useLanguage();
  const { pathname, search } = useLocation();
  const header = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const closeMenu = () => setOpen(false);

  useEffect(() => {
    if (pathname !== "/") {
      setActiveSection("");
      return;
    }
    let frame;
    const updateActiveSection = () => {
      const top = header.current.getBoundingClientRect().bottom + 24;
      let active = "";
      sections.forEach(({ id }) => {
        const section = document.getElementById(id);
        if (section && section.getBoundingClientRect().top <= top) active = id;
      });
      if (
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight - 2
      ) {
        active = "contact";
      }
      setActiveSection(active);
      frame = undefined;
    };
    const scheduleUpdate = () => {
      if (frame === undefined)
        frame = window.requestAnimationFrame(updateActiveSection);
    };
    updateActiveSection();
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
    };
  }, [pathname]);

  return (
    <header
      className="navbar"
      ref={header}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          closeMenu();
          event.currentTarget.querySelector("button").focus();
        }
      }}
    >
      <div className="navbar-container page-width">
        <Link
          to="/"
          className="navbar-logo"
          onClick={closeMenu}
          aria-label={t("QUICR – Startseite")}
        >
          <img src="/images/logo_offen.png" alt="" width="1917" height="755" />
        </Link>
        <button
          className="menu-icon"
          aria-label={isOpen ? t("Menü schließen") : t("Menü öffnen")}
          aria-expanded={isOpen}
          aria-controls="main-navigation"
          onClick={() => setOpen(!isOpen)}
        >
          {isOpen ? <FiX /> : <FiMenu />}
        </button>
        <nav
          id="main-navigation"
          aria-label={t("Hauptnavigation")}
          className={isOpen ? "nav-menu active" : "nav-menu"}
        >
          {sections.map(({ id, label }) => (
            <Link
              key={id}
              to={{
                pathname: "/",
                search: pathname === "/" ? search : "",
                hash: `#${id}`,
              }}
              onClick={closeMenu}
              className={activeSection === id ? "active" : undefined}
              aria-current={activeSection === id ? "location" : undefined}
            >
              {t(label)}
            </Link>
          ))}
        </nav>
        <LanguageSwitch />
      </div>
    </header>
  );
}
export default Navbar;
